import {
  apiGet, apiPost,
} from '../utils/api/api.helpers';
import type {
  EntityAccess,
  EntityAccessResponse, NewEntityAccess,
} from './entityAccess.repository';
import { newEntityAccessesToApiParams } from './entityAccess.repository.helpers';

export type EntityAccessInvitationId = number;

export type EntityAccessInvitation = EntityAccess & Readonly<{
  id: EntityAccessInvitationId;
  createdBy: Readonly<{
    id: number;
    name: string;
  }>;
  entityName?: string;
}>;

export type EntityAccessInvitationResponse = EntityAccessResponse & Readonly<{
  id: EntityAccessInvitationId;
  created_by: Readonly<{
    id: number;
    name: string;
  }>;
  entity_name?: string;
}>;

export type GetEntityAccessesInvitationsResponse = Readonly<{
  list: ReadonlyArray<EntityAccessInvitationResponse>;
}>;

export const createInvitation = (
  clientId: number,
  newEntityAccesses: ReadonlyArray<NewEntityAccess>,
): Promise<void> => {
  const requestUrl = `/api/clients/${clientId}/accesses/invitations`;
  return apiPost(requestUrl, {
    params: newEntityAccessesToApiParams(newEntityAccesses),
  });
};

export const getReceivedInvitations = (clientId: number): Promise<{ list: ReadonlyArray<EntityAccessInvitationResponse> }> => {
  const requestUrl = `/api/clients/${clientId}/accesses/invitations/received`;
  return apiGet(requestUrl);
};

export const getCreatedInvitations = (clientId: number): Promise<{ list: ReadonlyArray<EntityAccessInvitationResponse> }> => {
  const requestUrl = `/api/clients/${clientId}/accesses/invitations/created`;
  return apiGet(requestUrl);
};

export const acceptInvitation = (clientId: number, invitationId: EntityAccessInvitationId): Promise<void> => {
  const requestUrl = `/api/clients/${clientId}/accesses/invitations/${invitationId}/accept`;
  return apiPost(requestUrl);
};

export const deleteInvitation = (clientId: number, invitationId: EntityAccessInvitationId): Promise<void> => {
  const requestUrl = `/api/clients/${clientId}/accesses/invitations/${invitationId}/revoke`;
  return apiPost(requestUrl);
};
